import { Injectable } from '@angular/core';
import { PopoverController } from 'ionic-angular';

/*
  Generated class for the PopoverServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PopoverServiceProvider {

  constructor(public popoverCtrl: PopoverController) { }

  createOptionList(optionList: any[], event:any="") {
    return new Promise((resolve) => {
      let popover = this.popoverCtrl.create('PopoverModalPage', {
        data: optionList
      }, {
        showBackdrop: true,
        enableBackdropDismiss: true
      }
      );
      popover.onDidDismiss(data => {
        resolve(data);
        console.log('choosen action:', data);
      });
      popover.present({
        ev:event
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/popover-service/popover-service.ts